import _ from "lodash"
import {formatDate} from "./DateUtils"

export function isSameModel(m1, m2) {
  return _.isEqualWith(m1, m2, (att1, att2) => {
    if (typeof att1 !== 'object' && typeof att2 !== 'object') {
      if (typeof(att1) === 'number') {
        att1 += '' // converts a number to a string for comparison
      }
      if (typeof(att2) === 'number') {
        att2 += '' // converts a number to a string for comparison
      }
      return att1 === att2
    }
    // if nothing returned, comparison is handled by the lodash method instead
  })
}

export function isDirty(model, store, ignoreValuesFor=['userId', 'date']) {
  if (model.id){
    return !isSameModel(model, store.find(m => m.id === model.id))
  } else {
    const attributes = _.omit(model?.attributes || {}, ignoreValuesFor)
    return Object.values(attributes).some(v => !!v)
  }
}

export function newTimesheetEntry(date, user) {
  return {
    id: null,
    key: Math.random().toString(36),
    attributes: {
      userId: user.id,
      date: formatDate(date),
      time: '',
      projectTaskId: '',
      projectTaskCode: '',
      projectTaskName: '',
      comment: ''
    }
  }
}
